import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
import { Autocomplete, TextField } from "@mui/material";
// @mui

// ----------------------------------------------------------------------

RHFAutocomplete.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
  inputProps: PropTypes.object,
};

export default function RHFAutocomplete({
  name,
  label,
  helperText,
  inputProps,
  options,
  multiple,
  emptyValue = "",
  validateOnChange = true,
  ...other
}) {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          options={options}
          onChange={(event, newValue, reason) => {
            if (
              multiple === true &&
              Array.isArray(newValue) &&
              newValue.includes("All") &&
              reason === "selectOption"
            ) {
              setValue(name, options, { shouldValidate: validateOnChange });
            } else {
              if (reason === "clear") {
                setValue(name, multiple === true ? [] : emptyValue, { shouldValidate: validateOnChange });
              } else {
                setValue(
                  name,
                  multiple === true ? newValue.filter((t) => t !== "All") : newValue,
                  { shouldValidate: validateOnChange }
                );
              }
            }
          }}
          renderInput={(props) => (
            <TextField
              label={label}
              error={!!error}
              helperText={error ? error?.message : helperText}
              {...props}
              inputProps={{ ...props.inputProps, autoComplete: "new-password" }}
            />
          )}
          multiple={multiple}
          {...other}
        />
      )}
    />
  );
}